module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_gsshop_m.aec63e546cccb737f18d202c920cc8df.png";